import Header from '../../Plantilla/Header'; // Importa el componente Header
import Footer from '../../Plantilla/Footer'; // Importa el componente Footer
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import api from '../configuracion/config';
import ConsultarAnotacion from '../modales/modalConsultarMinutas';
import { InsertarAnotacion } from '../modales/modalInsertarMinutas';
import ActualizarAnotacion from '../modales/modalActualizarMinutas';
import ResponsivePagination from './ResponsivePagination';
import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/default.css';
import { estiloAlertify } from '../Funciones';
import { authStorage } from '../../utils/storage';

import {
  faPlus,
  faMagnifyingGlass,
  faXmark,
  faFilePen,
  faEye,
  faTrashCan,
  faUserSlash,
} from '@fortawesome/free-solid-svg-icons';
import './Minutas.css';

function TablaAnotaciones() {
  const [anotacion, setAnotacion] = useState([]);
  const strUsuario = authStorage.getUserId();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState('');
  const [mostrarModalConsultar, setMostrarModalConsultar] = useState(false);
  const [mostrarModalInsertar, setMostrarModalInsertar] = useState(false);
  const [mostrarModalActualizar, setMostrarModal] = useState(false);
  const [drwAnotacion, setDrwAnotacion] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [isMobileView, setIsMobileView] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 576 : false
  );
  const userTipo = authStorage.getUserType();

  const fetchData = async () => {
    try {
      if (userTipo === 'admin' || userTipo === 'supervisor') {
        const response = await api.get('/anotaciones');
        if (response.status === 200) {
          setAnotacion(response.data);
        }
      } else {
        const response = await api.post('/anotacion', { Usuario: strUsuario });
        if (response.status === 200) {
          setAnotacion(response.data);
        }
      }
    } catch (error) {
      console.error('Error al obtener las anotaciones:', error);
    }
  };

  useEffect(() => {
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(max-width: 575.98px)');
    const handleChange = (event) => {
      setIsMobileView(event.matches);
    };

    setIsMobileView(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  const handlePageClick = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setPageNumber(0);
  };

  const handleInputChange = (event) => {
    setSearchInput(event.target.value);
    setPageNumber(0);
  };

  const limpiarBusqueda = () => {
    setSearchInput('');
    setPageNumber(0);
  };

  const funcionMostrarModalInsertar = () => {
    setMostrarModalInsertar(true);
  };

  const funcionCerrarModalInsertar = () => {
    setMostrarModalInsertar(false);
  };

  const funcionGuardarAnotacion = async (formulario) => {
    const { dteFecha, tmeHora, strAsunto, strAnotacion, intIdSede } =
      formulario;
    const dttAnotacion = {
      dteFecha,
      tmeHora,
      strAsunto,
      strAnotacion,
      strUsuario: strUsuario,
      intIdSede,
    };

    try {
      //#REGION: Con validacion JavaScript
      // const confirmar = window.confirm(
      //   '¿ Desea guardar ésta Minuta ?'
      // );

      // if (confirmar) {
      //     const response = await api.post('/InsertarAnotacion', dttAnotacion);
      //     if (response.status === 200) {
      //         fetchData(strUsuario);
      //         funcionCerrarModalInsertar();
      //        }
      // }
      // #ENDREGION

      const response = await api.post('/InsertarAnotacion', dttAnotacion);
      if (response.status === 200) {
        fetchData(strUsuario);
        funcionCerrarModalInsertar();
        alertify.success('Guardado');
        estiloAlertify(1);
      }
    } catch (error) {
      console.error('Error al obtener las anotaciones:', error);
      alertify.error('Ocurrió un error al guardar la Minuta.');
      estiloAlertify(0);
    }
  };

  const funcionEliminarAnotacion = async (idAnotacion) => {
    alertify
      .confirm('¿Desea eliminar ésta Minuta?', async (e) => {
        if (e) {
          try {
            const response = await api.delete(
              `/EliminarAnotacion/${idAnotacion}`
            );
            if (response.status === 200) {
              setAnotacion(
                anotacion.filter((item) => item.idAnotacion !== idAnotacion)
              );
              fetchData();
              alertify.success('Eliminado. ');
              estiloAlertify(1);
            }
          } catch (error) {
            alertify.error('Error al eliminar la minuta');
             estiloAlertify(0);
          }          
        }
      })
      .set({
        labels: {
          ok: 'SI', // Etiqueta del botón OK
          cancel: 'NO', // Etiqueta del botón Cancelar
        },
        title: 'AVISO', // Título personalizado
      });
    
  };

  const funcionMostrarModalConsultar = (anotacion) => {
    const fechaISO = format(
      utcToZonedTime(parseISO(anotacion.dteFecha, 'dd/MM/yyyy'), 'UTC'),
      'yyyy-MM-dd'
    );
    const horaFormateada = format(
      utcToZonedTime(parseISO(anotacion.tmeHora, 'HH:mm:ss'), 'UTC'),
      'HH:mm:ss'
    );

    setDrwAnotacion({
      ...anotacion,
      dteFecha: fechaISO,
      tmeHora: horaFormateada,
    });

    setMostrarModalConsultar(true);
  };
  const funcionCerrarModalConsultar = () => {
    setMostrarModalConsultar(false);
  };

  const funcionMostrarModalActualizar = (anotacion) => {
    const fechaISO = format(
      utcToZonedTime(parseISO(anotacion.dteFecha, 'dd/MM/yyyy'), 'UTC'),
      'yyyy-MM-dd'
    );
    const horaFormateada = format(
      utcToZonedTime(parseISO(anotacion.tmeHora, 'HH:mm:ss'), 'UTC'),
      'HH:mm:ss'
    );

    setDrwAnotacion({
      ...anotacion,
      dteFecha: fechaISO,
      tmeHora: horaFormateada,
    });

    setMostrarModal(true);
  };

  const funcionCerrarModalActualizar = () => {
    setMostrarModal(false);
  };

  const funcionActualizarAnotacion = async (anotacionActualizar) => {
    if (anotacionActualizar.idAnotacion) {
      try {
        const response = await api.put(
          `/ActualizarAnotacion/${anotacionActualizar.idAnotacion}`,
          anotacionActualizar
        );
        if (response.status === 200) {
            alertify.success('Guardado.');
            estiloAlertify(1);

          fetchData();
          funcionCerrarModalActualizar();
        }
      } catch (error) {
        console.error('Error al actualizar la anotación:', error);
        alertify.error('Ocurrió un error al guardar la Minuta.');
      }
    }
  };

  // Lógica para aplicar el filtro
  const filteredData = anotacion.filter((drw) => {
    const formattedSearchInput = searchInput.toLowerCase();
    const sedeMatch = drw.strSede.toLowerCase().includes(formattedSearchInput);
    const AsuntoMatch = drw.strAsunto
      .toLowerCase()
      .includes(formattedSearchInput);
    const fecha = utcToZonedTime(parseISO(drw.dteFecha), 'UTC');
    const hora = utcToZonedTime(parseISO(drw.tmeHora), 'UTC');
    const formattedDate = format(fecha, 'dd/MM/yyyy');
    const formattedTime = format(hora, 'HH:mm');
    const fechaMatch = formattedDate.includes(formattedSearchInput);
    const horaMatch = formattedTime.includes(formattedSearchInput);
    return sedeMatch || fechaMatch || AsuntoMatch || horaMatch;
  });

  // Lógica para la paginación
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const currentPage =
    pageCount > 0 ? Math.min(pageNumber, pageCount - 1) : 0;
  const offset = currentPage * itemsPerPage;
  const paginatedData = filteredData.slice(offset, offset + itemsPerPage);
  const totalResultados = filteredData.length;
  const colSpanNoData =
    userTipo === 'admin' || userTipo === 'supervisor' ? 8 : 5;
  const goToFirstPage = () => setPageNumber(0);
  const goToLastPage = () => setPageNumber(Math.max(pageCount - 1, 0));
  const mostrarMinutasComoCards =
    isMobileView && (itemsPerPage === 10 || itemsPerPage === 50);
  const mostrarMinutasDosPorFila = isMobileView && itemsPerPage === 50;

  return (
    <div className="minutas-page">
      <header>
        <Header />
      </header>

      <main
        className="container-fluid mt-2"
        style={{ flex: '1', minHeight: 'calc(100vh - 20px)' }}
      >
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white">
            <div className="row g-2 align-items-center">
              <div className="col-lg-5 col-md-12">
                <h5 className="card-title text-secondary m-0">Minutas</h5>
                <small className="text-muted">
                  {totalResultados} resultado{totalResultados === 1 ? '' : 's'}
                </small>
              </div>
              <div className="col-lg-5 col-md-8">
                <div className="input-group input-group-sm minutas-search">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por fecha, hora, asunto o sede"
                    value={searchInput}
                    onChange={handleInputChange}
                  />
                  {searchInput && (
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={limpiarBusqueda}
                      title="Limpiar búsqueda"
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-lg-2 col-md-4 text-md-end text-sm-start">
                <button
                  className="btn btn-success btn-sm w-100"
                  onClick={funcionMostrarModalInsertar}
                >
                  <FontAwesomeIcon icon={faPlus} className="me-1" /> Nueva
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="d-flex justify-content-end align-items-center gap-2 small mb-3">
              <label htmlFor="itemsPerPageMinutas" className="text-secondary mb-0">
                Mostrar
              </label>
              <select
                id="itemsPerPageMinutas"
                className="form-select form-select-sm w-auto"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="text-secondary">registros</span>
            </div>
            {mostrarMinutasComoCards ? (
              <div
                className={`minutas-mobile-list ${
                  mostrarMinutasDosPorFila ? 'minutas-mobile-list--two-columns' : ''
                }`}
              >
                {paginatedData.length === 0 ? (
                  <div className="card minutas-mobile-card">
                    <div className="card-body text-center text-muted py-4">
                      No hay registros con los filtros actuales.
                    </div>
                  </div>
                ) : (
                  paginatedData.map((drw) => {
                    const fechaFormateada = format(
                      utcToZonedTime(parseISO(drw.dteFecha), 'UTC'),
                      'dd/MM/yyyy'
                    );
                    const horaFormateada = format(
                      utcToZonedTime(parseISO(drw.tmeHora), 'UTC'),
                      'HH:mm:ss'
                    );
                    const sedeFormateada =
                      typeof drw.strSede === 'string'
                        ? drw.strSede
                            .split(' ')
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(' ')
                        : '';

                    return (
                      <div key={drw.idAnotacion} className="card minutas-mobile-card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start gap-2 mb-3 minutas-mobile-header">
                            <div className="minutas-mobile-identity">
                              <span className="minutas-mobile-overline">Minuta</span>
                              <h6 className="mb-1 minutas-mobile-title">
                                {drw.strAsunto}
                              </h6>
                              <p className="mb-0 small minutas-mobile-subtitle">
                                {fechaFormateada} · {horaFormateada}
                              </p>
                            </div>
                            <span className="badge rounded-pill minutas-mobile-badge">
                              {sedeFormateada}
                            </span>
                          </div>

                          <div className="minutas-mobile-fields small">
                            <div className="minutas-mobile-field">
                              <span className="minutas-mobile-label">Fecha</span>
                              <span className="minutas-mobile-value">{fechaFormateada}</span>
                            </div>
                            <div className="minutas-mobile-field">
                              <span className="minutas-mobile-label">Hora</span>
                              <span className="minutas-mobile-value">{horaFormateada}</span>
                            </div>
                            <div className="minutas-mobile-field">
                              <span className="minutas-mobile-label">Sede</span>
                              <span className="minutas-mobile-value">{sedeFormateada}</span>
                            </div>
                            {(userTipo === 'admin' || userTipo === 'supervisor') && (
                              <div className="minutas-mobile-field">
                                <span className="minutas-mobile-label">Usuario</span>
                                <span className="minutas-mobile-value">{drw.strUsuario}</span>
                              </div>
                            )}
                            {(userTipo === 'admin' || userTipo === 'supervisor') && (
                              <div className="minutas-mobile-field">
                                <span className="minutas-mobile-label">Nombre</span>
                                <span className="minutas-mobile-value">
                                  {drw.strNombres === null ? 'Eliminado' : drw.strNombres}
                                </span>
                              </div>
                            )}
                          </div>

                          <div className="minutas-mobile-note mt-3">
                            <span className="minutas-mobile-label d-block mb-2">
                              Anotacion
                            </span>
                            <p className="mb-0 small minutas-mobile-note-text">
                              {drw.strAnotacion}
                            </p>
                          </div>

                          {(userTipo === 'admin' || userTipo === 'supervisor') && (
                            <div className="d-flex justify-content-end gap-2 mt-3 minutas-mobile-actions">
                              <button
                                type="button"
                                className="btn btn-outline-success btn-sm minutas-mobile-action-btn"
                                onClick={() => funcionMostrarModalConsultar(drw)}
                                title="Ver detalle"
                              >
                                <FontAwesomeIcon icon={faEye} className="me-1" />
                                Ver
                              </button>

                              {userTipo === 'admin' && (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm minutas-mobile-action-btn"
                                    onClick={() => funcionMostrarModalActualizar(drw)}
                                    title="Editar minuta"
                                  >
                                    <FontAwesomeIcon icon={faFilePen} className="me-1" />
                                    Editar
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm minutas-mobile-action-btn"
                                    onClick={() => funcionEliminarAnotacion(drw.idAnotacion)}
                                    title="Eliminar minuta"
                                  >
                                    <FontAwesomeIcon icon={faTrashCan} className="me-1" />
                                    Eliminar
                                  </button>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            ) : (
              <div className="table-responsive tablescroll d-sm-block minutas-table-wrapper">
                <table className="table table-hover table-sm table-bordered">
                  <thead className="table table-light">
                    <tr>
                      <th className="col-1 small text-dark ">Fecha</th>
                      <th className="col-1 small text-dark ">Hora</th>
                      <th className="small text-dark ">Asunto</th>
                      <th className="small text-dark ">Anotacion</th>
                      <th className="small  text-center text-dark ">Sede</th>
                      {(userTipo === 'admin' || userTipo === 'supervisor') && (
                        <th className="small text-center text-dark ">
                          Usuario
                        </th>
                      )}
                      {(userTipo === 'admin' || userTipo === 'supervisor') && (
                        <th className="small text-center text-dark ">
                          Nombres
                        </th>
                      )}
                      {(userTipo === 'admin' || userTipo === 'supervisor') && (
                        <th className="small col-1 text-center text-white bg-success">
                          Acciones
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="small align-middle">
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan={colSpanNoData} className="text-center text-muted py-4">
                          No hay registros con los filtros actuales.
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((drw) => (
                        <tr key={drw.idAnotacion}>
                          <td className="d-none">{drw.idAnotacion}</td>
                          <td className="small">
                            {format(
                              utcToZonedTime(parseISO(drw.dteFecha), 'UTC'),
                              'dd/MM/yyyy'
                            )}
                          </td>
                          <td className="small">
                            {format(
                              utcToZonedTime(parseISO(drw.tmeHora), 'UTC'),
                              'HH:mm:ss'
                            )}
                          </td>
                          <td className="small ">{drw.strAsunto}</td>
                          <td className="small">{drw.strAnotacion}</td>
                          <td className="small text-center">
                            {typeof drw.strSede === 'string'
                              ? drw.strSede
                                  .split(' ')
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1).toLowerCase()
                                  )
                                  .join(' ')
                              : ''}
                          </td>
                          {(userTipo === 'admin' ||
                            userTipo === 'supervisor') && (
                            <td className="small  text-center ">
                              {drw.strUsuario}
                            </td>
                          )}
                          {(userTipo === 'admin' ||
                            userTipo === 'supervisor') && (
                              <td className="small text-center">
                                {drw.strNombres === null ? (
                                  <span className="text-danger"> <FontAwesomeIcon icon={faUserSlash} /> Eliminado</span>
                                ) : (
                                  <span>{drw.strNombres}</span>
                                )}
                            </td>
                          )}
                          {userTipo === 'admin' && (
                            <td className="text-center">
                              <div
                                className="btn-group "
                                role="group"
                                aria-label=""
                              >
                                <button
                                  className="btn  btn-sm ps-0"
                                  onClick={() =>
                                    funcionMostrarModalConsultar(drw)
                                  }
                                  title="Ver detalle"
                                >
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    className="text-success"
                                  />
                                </button>

                                <button
                                  className="btn  btn-sm ps-0"
                                  onClick={() =>
                                    funcionMostrarModalActualizar(drw)
                                  }
                                  title="Editar minuta"
                                >
                                  <FontAwesomeIcon
                                    icon={faFilePen}
                                    className="text-secondary"
                                  />
                                </button>
                                <button
                                  className="btn  btn-sm  ps-0"
                                  onClick={() =>
                                    funcionEliminarAnotacion(drw.idAnotacion)
                                  }
                                  title="Eliminar minuta"
                                >
                                  <FontAwesomeIcon
                                    icon={faTrashCan}
                                    className="text-danger"
                                  />
                                </button>
                              </div>
                            </td>
                          )}

                          {userTipo === 'supervisor' && (
                            <td className="text-center">
                              <div
                                className="btn-group"
                                role="group"
                                aria-label=""
                              >
                                <button
                                  className="btn btn-sm  "
                                  onClick={() =>
                                    funcionMostrarModalConsultar(drw)
                                  }
                                  title="Ver detalle"
                                >
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    className="text-success"
                                  />
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="card-footer bg-white">
            <ResponsivePagination
              pageCount={pageCount}
              currentPage={currentPage}
              onPageChange={handlePageClick}
              onFirstPage={goToFirstPage}
              onLastPage={goToLastPage}
            />
          </div>
          
        </div>
        <div>
          <InsertarAnotacion
            mostrarModalInsertar={mostrarModalInsertar}
            cerrarModalInsertar={funcionCerrarModalInsertar}
            guardarModalInsertar={funcionGuardarAnotacion}
          />
          {drwAnotacion && (
            <ActualizarAnotacion
              mostrarModalActualizar={mostrarModalActualizar}
              cerrarModalActualizar={funcionCerrarModalActualizar}
              actualizarModal={funcionActualizarAnotacion}
              drwAnotacion={drwAnotacion}
            />
          )}
          {drwAnotacion && (
            <ConsultarAnotacion
              mostrarModalConsultar={mostrarModalConsultar}
              cerrarModalConsultar={funcionCerrarModalConsultar}
              drwAnotacion={drwAnotacion}
            />
          )}
        </div>
       
      </main>

      <footer>
     < Footer/>
    </footer>
    </div>
  );
}

export default TablaAnotaciones;
